/**
 * LoginService
 *
 * @module client/src/app/shared/services
 */
import { Injectable } from '@angular/core';
import { rx, Observable } from '@shared/rx';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '@store/reducers';
import { IUserSession } from '@store/reducers/session';

/**
 * # LoginService
 * Defines the service for establishing if user is logged in
 */
@Injectable()
export class LoginService {
  /**
   * Initialize the service
   * Services need initialization in the constructor.
   */
  public constructor(private ngRedux: NgRedux<IAppState>) {}

  /**
   * This getter returns the observable which provides the value
   * for understanding if user is logged in
   */
  public get isLoggedIn(): Observable<boolean> {
    return this.ngRedux.select('userSession').pipe(
      rx.filter((userSession: IUserSession) => userSession.applicationStarted),
      rx.map(
        (userSession: IUserSession) =>
          !!userSession.accessToken || !!userSession.personalToken,
      ),
    );
  }
}
